import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

// Bridges the v2 sections ({ pt, en } copy objects) onto the site's react-i18next language.
export function useLang() {
  const { i18n } = useTranslation()
  const lang = i18n.language?.toLowerCase().startsWith('en') ? 'en' : 'pt'
  const t = useCallback((entry) => (entry && typeof entry === 'object' ? (entry[lang] ?? entry.en) : entry), [lang])
  return { lang, t }
}
